import React from 'react'
import {Field} from 'formik'
import {useIntl} from 'react-intl'
import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  status: 'VALIDATED'
}

const FilterForm = () => {
  const intl = useIntl()
  const statuses = [
    'PENDING_VALIDATION',
    'VALIDATED',
    'DELETED',
    'LOCKED'
  ]

  return (
    <>
      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map((s:string) => {
          return { value: s, label: intl.formatMessage({id: `CUSTOMER_STATUS_${s}`})}
        })}
      />

    </>
  )
}

export {FilterForm, initialFilters}
